export default [
  {
    label: 'Contact',
    value: 'person',
  },
  {
    label: 'Company',
    value: 'business',
  },
];
